<template>
  <div>
    <Teleport to="#settings-group-header">
      <T>Логирование</T>
    </Teleport>  

    <Teleport to="#settings-group-actions">
      <v-btn test-tag="tag-273"
        text
        color="primary"
        @click="save"
        :loading="loading"
        :disabled="loading"
      >
        <v-icon>mdi-content-save</v-icon>
        <T>Сохранить</T>
      </v-btn>
    </Teleport>
    
    <Logging :loading="loading" :config="$store.getters.config.log" ref="form"/>
  </div>
</template>

<script>

import Teleport from 'vue2-teleport'
import Logging from '../../components/settings/logging'


export default {
  data: () => ({
    loading: false
  }),
  methods: {
    async save(){
      this.loading = true
      try {
        let new_config = {log: this.$refs.form.submit()}
        
        await this.$store.dispatch('updateConfig', new_config)

        this.$store.dispatch('throwTimeoutMessage', {
          message_data: this.$t('Изменения сохранены'),
          message_class: 'success'
        })

      } catch (e) {
        this.$store.dispatch('throwTimeoutMessage', {
          message_data: `${e.message}`,
          message_class: 'error'
        })
        this.loading = false
      } finally {
        this.loading = false
      }
    }
  },
  components: {
    Teleport,
    Logging
  }
}
</script>